export default __webpack_public_path__ + "static/child_care-c42735e6d7e34e1c647dcd637bb5a436.png";